import { FormControl, MenuItem, Select } from '@mui/material';
import useApi from '../../api';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import { PaginationType } from '../../api/types';
import { FilePool } from '../../api/types/cms';
import * as React from 'react';
import { SelectChangeEvent } from '@mui/material/Select/SelectInput';
import { useTranslation } from '../../contexts/TranslationContext';

type FilePoolSelectProps = {
    selectedPoolId?: string;
    onPoolChange?: (selectedPool: FilePool) => void;
    fullWidth?: boolean;
    disabled?: boolean;
};

interface FilePoolSelectItem {
    key: string;
    value: string;
    'data-pool': FilePool;
}

export default function FilePoolSelect({
    selectedPoolId,
    onPoolChange,
    fullWidth,
    disabled = false,
}: FilePoolSelectProps) {
    const { translate } = useTranslation();
    const { cms } = useApi();

    const [pagination, setPagination] = useState<PaginationType>({
        data: [],
        limit: 0,
        max_length: 0,
        has_next: false,
        offset: 0,
        length: 0,
    });

    const loadPools = () => {
        cms.getPools(50, 0)
            .then(response => {
                if (response && !response.error) {
                    setPagination(response);
                }
            })
            .catch(console.log);
    };

    useEffect(loadPools, [cms]);

    const onChange = (event: SelectChangeEvent, child: ReactNode) => {
        if (child) {
            // @ts-ignore
            const props: FilePoolSelectItem = child.props;
            if (props) {
                onPoolChange && onPoolChange(props['data-pool']);
            }
        }
    };

    const renderPoolSelectItem = (pool: FilePool) => (
        <MenuItem
            key={pool.id}
            value={pool.id}
            data-pool={pool}
            selected={selectedPoolId === pool.id}>
            {pool.name}
        </MenuItem>
    );

    return useMemo(() => {
        return (
            <FormControl>
                <Select
                    disabled={disabled}
                    value={
                        pagination.max_length > 0
                            ? selectedPoolId
                                ? selectedPoolId
                                : 'all'
                            : 'all'
                    }
                    onChange={onChange}
                    fullWidth={fullWidth}>
                    <MenuItem
                        key={'all'}
                        value={'all'}
                        data-pool={{ id: 'all' }}
                        selected={!selectedPoolId}>
                        {translate('pages.cms.files.pool.all_files')}
                    </MenuItem>
                    {pagination.data.map(renderPoolSelectItem)}
                </Select>
            </FormControl>
        );
    }, [pagination, selectedPoolId, fullWidth, translate]);
}
